import React from "react";

function FlowHero({ image, eyebrow, title, lead, steps, activeStep }) {
  const bg = React.useRef(null);

  React.useEffect(() => {
    if (window.innerWidth <= 991) return undefined;
    const updateScroll = () => {
      if (!bg.current) return;
      const offset = Math.min(window.pageYOffset, 400) / 4;
      bg.current.style.transform = "scale(1.06) translate3d(0," + offset + "px,0)";
    };
    window.addEventListener("scroll", updateScroll);
    return () => window.removeEventListener("scroll", updateScroll);
  }, []);

  return (
    <header className="hm-fhero">
      <div
        className="hm-fhero-bg"
        ref={bg}
        style={{ backgroundImage: "url(" + image + ")" }}
      ></div>
      <div className="hm-fhero-scrim"></div>
      <div className="hm-fhero-inner">
        {eyebrow && <span className="hm-fhero-eyebrow">{eyebrow}</span>}
        <h1>{title}</h1>
        {lead && <p className="hm-fhero-lead">{lead}</p>}
        {steps && steps.length > 0 && (
          <ol className="hm-steps">
            {steps.map((step, i) => (
              <li
                className={
                  "hm-step" +
                  (i === activeStep ? " is-active" : "") +
                  (i < activeStep ? " is-done" : "")
                }
                key={step}
                aria-current={i === activeStep ? "step" : undefined}
              >
                <span className="hm-step-n">{i < activeStep ? "✓" : i + 1}</span>
                <span>{step}</span>
              </li>
            ))}
          </ol>
        )}
      </div>
    </header>
  );
}

export default FlowHero;
